import { render, staticRenderFns } from "./causesuper.vue?vue&type=template&id=132ce6af&"
import script from "./causesuper.vue?vue&type=script&lang=js&"
export * from "./causesuper.vue?vue&type=script&lang=js&"
import style0 from "./causesuper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports